export function useTheme() {
  const theme = useCookie<'light' | 'dark'>('theme', {
    default: () => 'light',
    maxAge: 60 * 60 * 24 * 365,
  })

  const isDark = computed(() => theme.value === 'dark')

  const applyTheme = (value: 'dark' | 'light') => {
    theme.value = value

    if (import.meta.client) {
      document.documentElement.classList.toggle('dark', value === 'dark')
    }
  }

  const toggleTheme = () => {
    applyTheme(theme.value === 'dark' ? 'light' : 'dark')
  }

  if (import.meta.client) {
    applyTheme(theme.value)
  }

  return {
    theme,
    isDark,
    toggleTheme,
    applyTheme,
  }
}
